<template>
    <div class="checkbox-filter" :class="filterKey">
        <div class="type uk-h6">{{ title }}</div>

        <simplebar v-if="scrollable" class="filter-options-scrollable" data-simplebar-auto-hide="false">
            <filter-options :isDepartment="isDepartment" :items="items" :activeItems="activeItems" @filter-updated="emitFilter" />
        </simplebar>
        <filter-options v-else :isDepartment="isDepartment" :items="items" :activeItems="activeItems" @filter-updated="emitFilter" />

    </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';

const FilterOptions = {
    template: `
        <div class="filter-options">
            <div v-if="isDepartment" class="checkbox-wrapper">
                <label class="uk-cursor-pointer" :class="{ checked: activeItems.length === 0 }">
                    <input class="uk-checkbox uk-margin-xsmall-right"
                           type="checkbox"
                           :checked="activeItems.length === 0"
                           @change="$emit('filter-updated', null)">
                    {{ $t("message.all_departments") }}
                </label>
            </div>
            <div v-for="item in items" :key="item.id" class="checkbox-wrapper">
                <label class="uk-cursor-pointer" :class="{ checked: activeItems.includes(item.id) }">
                    <input class="uk-checkbox uk-margin-xsmall-right"
                           type="checkbox"
                           :checked="activeItems.includes(item.id)"
                           @change="$emit('filter-updated', item.id)">
                    {{ item.name }}
                </label>
            </div>
        </div>
    `,
    props: ['isDepartment', 'items', 'activeItems'],
    name: 'filter-options'
};

export default {
    name: "checkbox-filter",
    components: {
      simplebar,
      FilterOptions
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
        activeItems: {
            type: Array,
            required: true,
        },
        filterKey: {
            type: String,
            required: true,
        },
        isDepartment: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        emitFilter(itemId) {
            this.$emit('filter-updated', itemId);
        }
    }
}
</script> 
